import React from "react";
import { Slide } from "react-slideshow-image";
import {SHOPY_URL} from "../../../models/constants";
import {NavLink} from "react-router-dom";

const Banners = () => {
  const MiddleBannerHome = ({ upperText, middleText, callToActionText, href, target, external }) => (
    <div className="middle-banner-home">
      <div className="upper">{upperText}</div>
      <div className="middle">{middleText}</div>
      {callToActionText ? external ?
        <a href={href} target={target || '_self'}>
          <div className="call-to-action">
            <span>{callToActionText}</span>
          </div>
        </a>
        :
      <NavLink to={href} target={target || '_self'}>
        <div className="call-to-action">
          <span>{callToActionText}</span>
        </div>
      </NavLink>
      : null}
    </div>
  );
  return (
    <div
      id="carouselExampleControls"
      className="carousel slide"
      data-ride="carousel"
    >
      <div>
        <Slide easing="ease" autoplay={true} arrows={false} duration={2000}>
          <div
            className="banner-home"
            style={{
              width: "100%",
              height: "640px",
              backgroundImage: `url(${
                require("../../../img/banners-home/banner-home-1.png").default
              })`,
              backgroundPosition: '70% center',
            }}
          >
            <MiddleBannerHome
              upperText="Bienvenidos #Chocolovers"
              middleText="Mucho más que una tentación"
              callToActionText="COMPRÁ ONLINE"
              href={SHOPY_URL}
              external={true}
              target={'_blank'}
            ></MiddleBannerHome>
          </div>
          <div
            className="banner-home"
            style={{
              width: "100%",
              height: "640px",
              backgroundImage: `url(${
                require("../../../img/banners-home/banner-home-2.png").default
              })`,
              backgroundPosition: 'center right',
            }}
          >
            <MiddleBannerHome
              upperText="Experiencia en Chocolates"
              middleText="Amamos lo que hacemos"
              callToActionText="VER PRODUCTOS"
              href="/productos"
            ></MiddleBannerHome>
          </div>
          <div
            className="banner-home"
            style={{
              width: "100%",
              height: "640px",
              backgroundImage: `url(${
                require("../../../img/banners-home/banner-home-3.png").default
              })`,
              backgroundPosition: 'center',
            }}
          >
            <MiddleBannerHome
              upperText="Pensá en chocolate"
              middleText="Somos el regalo perfecto"
              callToActionText="SORPRENDÉ"
              href={SHOPY_URL}
              external={true}
              target={'_blank'}
            ></MiddleBannerHome>
          </div>
          <div
            className="banner-home"
            style={{
              width: "100%",
              height: "640px",
              backgroundImage: `url(${
                require("../../../img/banners-home/banner-home-4.png").default
              })`,
              backgroundPosition: 'center',
            }}
          >
            <MiddleBannerHome
              upperText="Visitanos siempre!"
              middleText="Descubre donde estamos"
              callToActionText="SUCURSALES"
              href="/sucursales"
            ></MiddleBannerHome>
          </div>
        </Slide>
      </div>
    </div>
  );
};
export default Banners;
